import { Container, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import BannerImage from "../../../img/banner-image-v2.png";

const Banner = () => {
  const loginData = useSelector((state: RootState) => state.login);

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        marginBottom: "1rem",
        paddingY: { xs: "0rem", sm: "1rem", md: "2.5rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "45%" },
          padding: {
            xs: "1rem 0px 2rem 0px",
            sm: "1.5rem 0px 4rem 0px",
            md: "3rem 0px 4rem 0px",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography variant="bannerTitle">{"The platform for "}</Typography>
          <Typography
            variant="bannerTitle"
            sx={{ color: "#4663ff !important" }}
          >
            {"footballshirt collectors"}
          </Typography>
          <Typography variant="bannerTitle">
            {" that takes the hobby experience to the max."}
          </Typography>
        </Box>
        <Box
          sx={{ marginTop: "2rem", textAlign: { xs: "center", md: "left" } }}
        >
          <Typography variant="bannerDescription">
            Upload and manage your collection, track your collection’s value,
            get your shirts authenticated, discover shirts from other
            collectors, engage in the community and more...
          </Typography>
        </Box>
        <Box
          sx={{ marginTop: "2rem", textAlign: { xs: "center", md: "left" } }}
        >
          <Link to={loginData?.userId ? "/my-profile" : "/sign-in"}>
            <a className="default-btn move-right">
              <span style={{ fontStyle: "italic" }}>Create Collection</span>
            </a>
          </Link>
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", sm: "55%" },
          display: "flex",
          justifyContent: { xs: "center", md: "flex-end" },
        }}
      >
        <img
          className="bannerImage"
          src={BannerImage}
          alt="banner image"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
          }}
        />
      </Box>
    </Container>
  );
};

export default Banner;
